import { useSettingsStore } from "~/stores/settings";
import { useSubscriptionStore } from "~/stores/user/subscription";

/**
 * Loads the subscription data before a job-feed page renders when the exact
 * tender dates are enabled, because `useTenderDateVisibility` shows them only
 * to professionals with a paid zone subscription. Runs on the server for a
 * full page load and on the client for a navigation.
 */
export default async function tenderDateSubscriptionMiddleware({ $pinia }) {
  if (!useSettingsStore($pinia).showTenderDate) {
    return;
  }
  await useSubscriptionStore($pinia).load();
}
